export default {
    // UI
    alt_filters_filter: "Välj rätt LED alternativ",
    ballast_notice: "Förkopplingsdonets kompatibilitet för HF-don (HF) måste kontrolleras.",
    ballast_notice_tled_link_text: "LED-lysrör",
    ballast_notice_pl_led_link_text: "LED PL-lampor",

    // LED facets
    tiering: "Serie",
    ballast_compatibility: "Kompatibilitet med driftdon",
    lifetime: "Livslängd",
    lumen: "Lumen",
    led_no_recommendations: "Det finns inga LED-alternativ för denna produkt.",

    home_search_for_product: "Sök på din produkt",
    conventional_alternative: "Konventionellt alternativ",
    led_alternative: "LED-alternativ",
    search_filters_filter: "Filter",
    search_submit: "Sök produkt",
    results: "Resultat",
    selected_product: "Vald produkt",
    search_input: "Skriv in (del av) produktkod eller beskrivning",
    what_type_are_you_looking_for: "Vilken typ av produkt vill du byta?",
    recommendations_singular: "Rekommendationer",
    recommendations_plural: "Rekommendationer",
    your_product: "Din produkt",
    search_filters_reset: "Återställ filter",
    results_specify: "Det finns fler än 10 resultat, vänligen specificera din sökning",
    energy_efficient: "Energi effektiv",
    active_filters: "Aktiva filter",
    card_action: "Katalog",
    card_show_more: "Visa mer",
    card_show_less: "Visa mindre",
    card_alternative_fit: "Philips Best Alternative",
    card_perfect_fit: "Philips Best Fit",
    no_results_found: "Inga resultat kunde hittas. Försök med en annan sökning",
    results_no_recommendations: "Kört fast? Kontakta din sälj- eller ljusspecialist så får du hjälp.",
    search_filter_product_type: "Produkttyp",
    lighting_type: "Typ av ljuskällor",
    ean: "EAN",
    product_code: "Produktkod",
    eoc: "EOC",
    family: "Familj",
    discrete_wattage: "Effekt",
    wattage: "Effekt",
    brand: "Varumärke",
    driver_type: "Drivdon",
    number_of_lamps: "Antal ljuskällor",
    length: "Längd",
    color: "Färg",
    base: "Bas",
    local_eoc: "Lokal kod",
    ignitor: "Tändare",
    height: "Höjd",
    width: "Bredd",
    mounting_hole: "Håltagning",
    mains_voltage: "Nätspänning",
    thermal_protection: "Termiskt skydd",
    delta_temperature: "Temperatur-delta",
    energy_efficiency: "Energieffektivitet",
    losses: "Förluster",
    lamp_current: "Ström",
    pf_cap: "pF-gräns",
    type_of_lamp: "Typ av ljuskälla",
    driver: "Drivdon",
    lamp: "Ljuskälla",
    energy_saving: "Energisparande",
};
